// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falAlignCenter: CreateIconOptions = {
  "displayName": "FALAlignCenter",
  "viewBox": "0, 0, 448, 512",
  "d": "M112 48c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L112 48zM16 176c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 176zM96 320c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16zM16 432c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 432z"
};
